// extracted by mini-css-extract-plugin
export default {"container":"CareDetails_container__XDvky","top":"CareDetails_top__Q6sFH","bottom":"CareDetails_bottom__y7W7l"};